import { PRecord } from '../types';

export function removeCssCharset(str: string): string {
	return str.replace(/@charset\s+['"]?[^;]*['"]?\s*;/gi, '');
}

export function cssToStyleBody(props: PRecord<string, string>, allImportant = false): string {
	const parts: string[] = [];

	for (const key in props) {
		if (/[^a-z-]/.test(key)) {
			throw new Error('CSS property name has unhandled characters: ' + key);
		}

		const val = props[key];

		if (val) {
			if (/[&<>:]/.test(val)) {
				throw new Error('CSS property name has unhandled characters: ' + val);
			}

			if (allImportant) {
				parts.push(`${key}:${val} !important`);
			} else {
				parts.push(`${key}:${val}`);
			}
		}
	}

	const joined = parts.join(';');
	return joined;
}

export function cssToAttrStr(props: PRecord<string, string>): string {
	const joined = cssToStyleBody(props);
	if (/[&<>]/.test(joined)) {
		throw new Error('CSS style value has unhandled characters: ' + joined);
	}

	return joined;
}
